export default "/kiban/_next/static/images/title-aa7691c00760edc5ce420d701fc6aaab.png";